module.exports = __webpack_public_path__ + "img/CCSLogo_Variation.e18e7d62.svg";